import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { DisableEnableControls, GetFormatedDateWithTime } from '../../../common/Utils'
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";
import StatusTab from "./tabs/StatusTab";
import AdditionalTab from "./tabs/AdditionalTab";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery'
import UOMTab from "./tabs/UOMTab";
import LotTab from "./tabs/LotTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import HandlingTab from "./tabs/HandlingTab";
import KitTab from "./tabs/KitTab";
import LocationsTab from "./tabs/LocationsTab";
import data from "../../../assets/apiRoutes.json";
import { IM } from "../../../const/constants";
import { ItemTypes, LocationStatus, Options, TransactionStatus, TransactionTypes,CalcMethod as CalcMethodEnum,PriceSource as PriceSourceEnum,PriceMethod as PriceMethodEnum  } from "../../../enum/Enum";
import { MESSAGES } from "../../../common/Messages";
import ReorderTab from "./tabs/ReorderTab";
import CostPriceTab from "./tabs/CostPriceTab";
import MiscTab from "./tabs/MiscTab";

var skipDataLoading = false;
var reOrderMethodFlag = false;
var perviousItemType = null;
var profile = null;
var currentR_IDENTITY = null;
var currentRATESELECTION = 'N';
var currentCLASSCODE = null;
var currentSUBCLASSCODE = null;

/** Back enabled when the URL has a non-empty `id` query parameter. */
function hasItemIdInUrlSearch(search) {
    const id = new URLSearchParams(search || '').get('id');
    return id != null && String(id).trim() !== '';
}

function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        KeySequence: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        Module: null,
        RecordType: null,
        RProfile: null,
        ProfileCode: null,
        ItemCode: null,
        RWarehouse: null,
        Description1: null,
        Description2: null,
        RIdentity: null,
        IdentityId: null,
        ROemManufactureId: null,
        OemManufacturerCode: null,
        RDestinationId: null,
        ClassCode: null,
        SubClassCode: null,
        ItemType: ItemTypes.Item,
        AbcCode: null,
        Status: TransactionStatus.Active,
        StatusReasonCode: null,
        TaxStatus: Options.Yes,
        Comment: null,
        LocationType: null,
        RLocation: null,
        PhysicalCountCode: null,
        FreightClassCode: null,
        RGlDepartment: null,
        RCajobCode: null,
        InventoryUnitUom: null,
        PiecesPerUnitUom: null,
        PiecesPerUnitQuantity: null,
        UnitsPerPackageUom: null,
        RItemKittCode: null,
        UnitsPerPackageQuantity: null,
        ArTradeDiscountFlag: null,
        PackagesPerShippingUnitUom: null,
        ArTermsDiscountFlag: null,
        PackagesPerShippingUnitQty: null,
        SaleIncrementQuantity: null,
        UnitVolumeUom: null,
        MinimumSalesQuantity: null,
        UnitVolumeQuantity: null,
        UserDefinedComment: null,
        UnitAreaUom: null,
        UnitAreaQuantity: null,
        UnitValueUom: null,
        UnitValueQuantity: null,
        WeightBasisFlag: null,
        NetWeightUom: null,
        NetWeightQuantity: null,
        GrossWeightUom: null,
        RProductCategory: null,
        GrossWeightQuantity: null,
        VendorItemCode: null,
        ReceiptUomDefault: null,
        ReceiptUomMultiple: null,
        ReceiptUomAlternative: null,
        ReceiptPackSize: null,
        ShipmentUomDefault: null,
        ShipmentUomMultiple: null,
        ShipmentUomAlternative: null,
        ShipmentPackSize: null,
        ShipSelection: null,
        StackHeight: null,
        PalletPatternRow: null,
        PalletPatternColumn: null,
        PalletPatternHeight: null,
        PalletSizeCode: null,
        BoxCode: null,
        HazardousFlag: null,
        CareInstructions: null,
        SpecificationCode: null,
        ItemSupcCode: null,
        BomExplosionFlag: null,
        MiscelleanousFeeFlag: null,
        StorageLocationType: null,
        StorageLocationPriorityFlag: null,
        SystemCode: null,
        AssemblyCode: null,
        PartCode: null,
        EmCostBucketNumber: null,
        TlFuelTaxFlag: null,
        TlFuelTaxCode: null,
        DateIntroduced: null,
        DateAvailable: null,
        DateExpiration: null,
        StorageBillingStartDate: null,
        StorageBillingEndDate: null,
        ItemSourceFlag: null,
        ReorderMethodFlag: 'N',
        ReorderInventoryMinimumQty: null,
        ReorderInventoryMaximumQty: null,
        ReorderMinimumDaysOnHand: null,
        ReorderMaximumDaysOnHand: null,
        ReorderQuantityEoqCalculated: null,
        ReorderQuantityEntered: null,
        ReorderQuantityOrderMultiple: null,
        ReorderSafetyQuantity: null,
        ReorderLeadTime: null,
        CostBasisMethodFlag: null,
        AverageCost: null,
        StandardCost: null,
        RPriceTable: null,
        CorePrice: null,
        MaximumPriceLevelForDiscount: null,
        AnniversaryBillingFlag: null,
        AnniversaryBillingDate: null,
        AnniversaryBillingQuantity: null,
        WarrantyFlag: null,
        WarrantyPeriodTypeFlag: null,
        WarrantyMonths: null,
        WarrantyMeterMiles: null,
        WarrantyMeterHours: null,
        UserDefinedCode1: null,
        UserDefinedCode2: null,
        UserDefinedCode3: null,
        UserDefinedCode4: null,
        UserDefinedCode5: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        UserDefinedCode8: null,
        UserDefinedCode9: null,
        UserDefinedCode10: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        RGlFund: null,
        ProfileGuid: null,
        LocationClassForwardPick: null,
        LocationClassReplenishment: null,
        LocationClassReserve: null,
        LocationSubclassForwardPick: null,
        LocationSubclassReplenishment: null,
        LocationSubclassReserve: null,
        LocationMaxUnitsForwardPick: null,
        LocationMinUnitsForwardPick: null,
        RLocationPrimaryReplenishment: null,
        RLocationPrimaryReserve: null,
        RLocationBackupForwardPick: null,
        RLocationBackupReplenishment: null,
        RLocationBackupReserve: null,
        LocationMinUnitsReplenishment: null,
        LocationMaxUnitsReplenishment: null,
        PalletReference: null,
        RHazardous: null,
        OnHand: null,
        InOrdered: null,
        OutOrdered: null,
        InReceiving: null,
        OutShipped: null,
        InBackOrder: null,
        OutBackOrder: null,
        InUnavailable: null,
        OutUnavailable: null,
        InFuture: null,
        OutFuture: null,
        Available: null,
        NetAvailable: null,
        RRateSchedule: null,
        PopupMessage: null,
        LastCost: null,
        InventoryQuantitySource: null,
        RBuyer: null,
        RateSource: null,
        RateSelection: null,
        Size1: null,
        Size2: null,
        StorageBilledDateLast: null,
        StorageBilledDateNext: null,
        MsdsFileName: null,
        RAssociateItem: null,
        AssociateDesc: null,
        PriceSource: null,
        PriceMethod: null,
        CalcMethod: null,
        PriceLevelA: null,
        PriceLevelB: null,
        PriceLevelC: null,
        PriceLevelD: null,
        PriceLevelE: null,
        RWarrantyCode: null,
        ManagementSource: null,
        PriceBasis: null,
        RFees: null,
        SubLotUniqueFlag: null,
        RfReceiptValidation: null,
        RfShipmentValidation: null,
        InTransactionNumber: null,
        DateLastReceipt: null,
        AcStandardUnitFactor: null,
        AcStandardWeightFactor: null,
        ItemPayGroup: null,
        RParticipant: null,
        CommissionBasis: null,
        CommissionAmount: null,
        RoundingMethod: null,
        RoundingFactor: null,
        AlternateStandardCost: null,
        AlternateAverageCost: null,
        AlternateLastCost: null,
        PrevStorageBilledDateLast: null,
        PrevStorageBilledDateNext: null,
        RecurringStorage: null,
        WebAccessibility: null,
        OmKitFlag: null,
        PmKitFlag: null,
        WarrantyFlagShipment: null,
        WarrantyMonthsShipment: null,
        CheckMaxDays: null,
        MaxDays: null,
        CheckLotExpiration: null,
        UpdateUomWeight: null,
        AutomaticallyUpdateQuantity: null,
        LocationAvailableDefault: null,
        LocationReasonCodeDefault: null,
        RItemGroup: null,
        ItemSubGroup: null,
        ItemMember: null,
        CheckReceiptDays: null,
        CheckShipmentDays: null,
        RImMandatedFees: null,
        ExpDateBasedOn: null,
        AddToExpDate: null,
        UserDefinedCode11: null,
        UserDefinedCode12: null,
        UserDefinedCode13: null,
        UserDefinedCode14: null,
        UserDefinedCode15: null,
        UserDefinedCode16: null,
        UserDefinedCode17: null,
        UserDefinedCode18: null,
        UserDefinedCode19: null,
        UserDefinedCode20: null,
        UserDefinedDate11: null,
        UserDefinedDate12: null,
        UserDefinedDate13: null,
        UserDefinedDate14: null,
        UserDefinedDate15: null,
        UserDefinedDate16: null,
        UserDefinedDate17: null,
        UserDefinedDate18: null,
        UserDefinedDate19: null,
        UserDefinedDate20: null,
        UserDefinedQuantity11: null,
        UserDefinedQuantity12: null,
        UserDefinedQuantity13: null,
        UserDefinedQuantity14: null,
        UserDefinedQuantity15: null,
        UserDefinedQuantity16: null,
        UserDefinedQuantity17: null,
        UserDefinedQuantity18: null,
        UserDefinedQuantity19: null,
        UserDefinedQuantity20: null,
        UserDefinedReference11: null,
        UserDefinedReference12: null,
        UserDefinedReference13: null,
        UserDefinedReference14: null,
        UserDefinedReference15: null,
        UserDefinedReference16: null,
        UserDefinedReference17: null,
        UserDefinedReference18: null,
        UserDefinedReference19: null,
        UserDefinedReference20: null,
        WmConsigneeExpDays: null,
        Reference1: null,
        Reference2: null,
        Reference3: null,
        Reference4: null,
        Reference5: null,
        UserDefinedComment2: null,
        OversellPercentage: null,
        SaleMaxQuantity: null,
        RContainerCode: null,
        ProdCategoryDesc: null,
        LocationCode: null,
        WarehouseId: null,
        WarehouseName: null,
        ContainerCode: null,
        Name: null,
        CoreItemUsage: null,
        ProfileDescription: null,
        PriceCode: null,
        Description: null,
        PriceA: null,
        PriceB: null,
        PriceC: null,
        PriceD: null,
        PriceE: null,
        LocationSubclassReplenishmen: null,
        ReorderQuantityEoqCalculate: null,
        ReorderQuantityOrderMultipl: null,
        WhId: null,
        Record: null,
        DisableCustomerLookup: null,
        ReceiptPutOnHold: null,
        HoldReasonCode: null,
        HoldDaysCount: null,
        LotCode: null,

    };
    const history = useHistory();
    const location = useLocation();
    const backButtonEnabled = useMemo(
        () => hasItemIdInUrlSearch(location.search),
        [location.search]
    );
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const [loadPriceDataGrid, setLoadPriceDataGrid] = useState(false);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const costPriceGridRef = useRef(null);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    
    const handleTabSelection = (e) => {
        setSelectedTabIndex(e.selectedIndex);
        // Resize grid when Cost/Price tab (index 2) is selected
        if (e.selectedIndex === 2 && costPriceGridRef.current && costPriceGridRef.current.instance) {
            setTimeout(() => {
                if (typeof costPriceGridRef.current.instance === 'function') {
                    const instance = costPriceGridRef.current.instance();
                    if (instance && typeof instance.updateDimensions === 'function') {
                        instance.updateDimensions();
                    }
                }
            }, 100);
        }
    };
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.RowId == "00000000-0000-0000-0000-000000000000") {
                await insertItem();
            }
            else {
                await updateItem();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setLoadPriceDataGrid(!loadPriceDataGrid);
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const updateDateFormats = (fields) => {
        fields.DateIntroduced = GetFormatedDateWithTime(formFields.DateIntroduced);
        fields.DateAvailable = GetFormatedDateWithTime(formFields.DateAvailable);
        fields.DateExpiration = GetFormatedDateWithTime(formFields.DateExpiration);
        fields.StorageBillingStartDate = GetFormatedDateWithTime(formFields.StorageBillingStartDate);
        fields.StorageBillingEndDate = GetFormatedDateWithTime(formFields.StorageBillingEndDate);
        fields.AnniversaryBillingDate = GetFormatedDateWithTime(formFields.AnniversaryBillingDate);
        fields.UserDefinedDate1 = GetFormatedDateWithTime(formFields.UserDefinedDate1);
        fields.UserDefinedDate2 = GetFormatedDateWithTime(formFields.UserDefinedDate2);
        fields.UserDefinedDate3 = GetFormatedDateWithTime(formFields.UserDefinedDate3);
        fields.UserDefinedDate4 = GetFormatedDateWithTime(formFields.UserDefinedDate4);
        fields.UserDefinedDate5 = GetFormatedDateWithTime(formFields.UserDefinedDate5);
        fields.UserDefinedDate6 = GetFormatedDateWithTime(formFields.UserDefinedDate6);
        fields.UserDefinedDate7 = GetFormatedDateWithTime(formFields.UserDefinedDate7);
        fields.UserDefinedDate8 = GetFormatedDateWithTime(formFields.UserDefinedDate8);
        fields.UserDefinedDate9 = GetFormatedDateWithTime(formFields.UserDefinedDate9);
        fields.UserDefinedDate10 = GetFormatedDateWithTime(formFields.UserDefinedDate10);
        fields.StorageBilledDateLast = GetFormatedDateWithTime(formFields.StorageBilledDateLast);
        fields.StorageBilledDateNext = GetFormatedDateWithTime(formFields.StorageBilledDateNext);
        fields.DateLastReceipt = GetFormatedDateWithTime(formFields.DateLastReceipt);
        fields.PrevStorageBilledDateLast = GetFormatedDateWithTime(formFields.PrevStorageBilledDateLast);
        fields.PrevStorageBilledDateNext = GetFormatedDateWithTime(formFields.PrevStorageBilledDateNext);
        fields.UserDefinedDate11 = GetFormatedDateWithTime(formFields.UserDefinedDate11);
        fields.UserDefinedDate12 = GetFormatedDateWithTime(formFields.UserDefinedDate12);
        fields.UserDefinedDate13 = GetFormatedDateWithTime(formFields.UserDefinedDate13);
        fields.UserDefinedDate14 = GetFormatedDateWithTime(formFields.UserDefinedDate14);
        fields.UserDefinedDate15 = GetFormatedDateWithTime(formFields.UserDefinedDate15);
        fields.UserDefinedDate16 = GetFormatedDateWithTime(formFields.UserDefinedDate16);
        fields.UserDefinedDate17 = GetFormatedDateWithTime(formFields.UserDefinedDate17);
        fields.UserDefinedDate18 = GetFormatedDateWithTime(formFields.UserDefinedDate18);
        fields.UserDefinedDate19 = GetFormatedDateWithTime(formFields.UserDefinedDate19);
        fields.UserDefinedDate20 = GetFormatedDateWithTime(formFields.UserDefinedDate20);
        if (fields.BomExplosionFlag === 'N' || fields.BomExplosionFlag == null) {
            fields.RItemKittCode = null;
        }
        return fields;
    }
    const insertItem = async () => {
        try {
            const url = "im/Item/Insert";
            let fields = updateDateFormats(formFields);

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    RowId: response.data.ROWID,
                    Record: response.data.RECORD
                }));
                notify(
                    {
                        message: "Item Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else {
                notify(
                    {
                        message: "Could not create item. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateItem = async () => {
        try {
            const url = "im/Item/Update";
            let fields = updateDateFormats(formFields);
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data || !response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Item Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }


        } catch (error) {
            console.error('Error submitting form:', error);

            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                var hasWarning = false;
                var hasConfirmation = false;
                var errorMessage = "";
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {

                    if (error.response.data.ERRORS[i].startsWith("[ItemTypeWarning]")) {
                        hasWarning = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeWarning]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else if (error.response.data.ERRORS[i].startsWith("[ItemTypeConfirmation]")) {
                        hasConfirmation = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeConfirmation]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else {
                        errorsArray.push(error.response.data.ERRORS[i]);
                    }
                }

                if (errorsArray.length > 0) {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
                else {
                    if (hasWarning) {
                        alert(errorMessage, "Warning");
                        setformFields(prevFields => ({
                            ...prevFields,
                            ItemType: perviousItemType
                        }));

                    }
                    else if (hasConfirmation) {

                    }
                }
            }
            else {
                notify(
                    {
                        message: "Could not create item. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = () => {
        primaryFormLoad();
        additionalFormLoad();
        handleUOMFormLoad();
        statusFormLookupsLoad();
        kitFormLookupsLoad();
        reorderFormLoad();
        costPriceFormLoad();
        handlingFormLoad();
    }

    const enableDisableControls = (name, disabled) => {
        if (formRefs && formRefs.current && formRefs.current[name]) {
            const ref = formRefs.current[name];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    instance.option('disabled', disabled);
                }
            }
        }
    }
    const primaryFormLoad = () => {

        loadLookupFromStaticData(formRefs, "ItemType", [{ id: 'I', name: "Item" }, { id: 'L', name: "Item/Lot" }, { id: 'S', name: "Item/Lot/Sublot" }, { id: 'U', name: "Item/Lot/Sublot/Unit" }]);
        loadLookupFromStaticData(formRefs, "Status", [{ id: 'A', name: "Active" }, { id: 'I', name: "Inactive" }]);
        loadLookupFromStaticData(formRefs, "ItemSourceFlag", [{ id: 'M', name: 'Manufactured' }, { id: 'P', name: 'Purchased' }, { id: 'O', name: 'Manufactured & Ordered' }, { id: 'R', name: 'Purchased & Ordered' }, { id: 'B', name: 'Brokered' }, { id: 'D', name: 'Drop-Ship' }]);
        loadLookupFromStaticData(formRefs, "TaxStatus", [{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }, { id: 'A', name: "Always Taxable" }]);
        if (formFieldsRef.current.RowId !== "00000000-0000-0000-0000-000000000000") {
            enableDisableControls('RProfile', true);
            enableDisableControls('RWarehouse', true);
        }
    }

    const additionalFormLoad = () => {
        loadLookupFromStaticData(formRefs, "RateSource", [{ id: 'I', name: "Item" }, { id: 'L', name: "Lot" }]);
        loadLookupFromStaticData(formRefs, "RateSelection", [{ id: 'N', name: "Show All Rate Schedules" }, { id: 'C', name: "Filter By Customer" }, { id: 'L', name: "Filter By Customer/Class" }, { id: 'S', name: "Filter By Customer/Class/Sub Class" }, { id: 'U', name: "Filter By Class" }, { id: 'V', name: "Filter By Sub Class" }]);

        if (formRefs.current['PrevStorageBilledDateLast']) {
            formRefs.current['PrevStorageBilledDateLast'].instance().option('disabled', true);
        }

        if (formRefs.current['PrevStorageBilledDateNext']) {
            formRefs.current['PrevStorageBilledDateNext'].instance().option('disabled', true);
        }
        loadLookupFromStaticData(formRefs, "RecurringStorage", [{ id: 'Y', name: "Yes, Always Generate Recurring Storage Charges" }, { id: 'N', name: "No, Never Generate Recurring Storage Charges" }]);
        loadLookupFromStaticData(formRefs, "ManagementSource", [{ id: 'I', name: "Item" }, { id: 'L', name: "Lot" }]);
        loadLookupFromStaticData(formRefs, "ReceiptPutOnHold", [{ id: 'N', name: "No" }, { id: 'Y', name: "Yes" }]);
        loadLookupFromStaticData(formRefs, "LocationAvailableDefault", [{ id: 'Y', name: "Yes, Available" }, { id: 'N', name: "No, Not Available" }]);

        //loadRateScheduleLookupFromDataSource();
        if (formRefs.current["RRateSchedule"]) {
            if (formFields.RRateSchedule) {
                formRefs.current["RRateSchedule"].instance().option('value', formFields.RRateSchedule);
            }

            if (formFields.RateSource && formFields.RateSource == "L") {
                formRefs.current['RRateSchedule'].instance().option('disabled', true);
            }
        }

    }

    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };



    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'im/Item/Delete'}`, formFields.RowId, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    if (!response.data.ERRORS.length > 0) {
                        notify(
                            {
                                message: MESSAGES.DELETE_SUCCESS,
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        history.push('/om/codes/item-data-entry-list');
                    }
                    else {
                        setLoadPanelVisible(false);
                        const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: MESSAGES.ERROR,
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                }
                catch (error) {

                    setLoadPanelVisible(false);

                    if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                    else {
                        notify(
                            {
                                message:MESSAGES.ERROR_FORM_SUBMISSION,
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                }
            }
        })
    }

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/om/codes/item-data-entry-create');
        EnableControlsForNewRecord();
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/${data.IM.GetItem}?ItemRowId=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                profile = res.data.Item2;

                if (responseData.RowId) {
                    skipDataLoading = true;
                    responseData.INVENTORYUNITNOTUSED = 1;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (responseData.ReOrderMethodFlag == "N") {
                        reOrderMethodFlag = true;
                    }
                    enableDisableControls("RProfile", true);
                    enableDisableControls("RWarehouse", true);

                    currentR_IDENTITY = responseData.RIdentity;
                    currentRATESELECTION = responseData.RateSelection;
                    currentCLASSCODE = responseData.ClassCode;
                    currentSUBCLASSCODE = responseData.SubClassCode;

                }
                else {
                    console.error('Failed to get item data');
                }
            });


        } catch (error) {
            console.error('Error failed to get item data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
    }, [props.id]);
    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const setReorderControlls = (disabled) => {
        enableDisableControls('ReorderInventoryMinimumQty', disabled);
        enableDisableControls('ReorderInventoryMaximumQty', disabled);
        enableDisableControls('ReorderMinimumDaysOnHand', disabled);
        enableDisableControls('ReorderMaximumDaysOnHand', disabled);
        enableDisableControls('ReorderQuantityEntered', disabled);
        enableDisableControls('ReorderQuantityEoqCalculated', disabled);
        enableDisableControls('ReorderQuantityOrderMultiple', disabled);
        enableDisableControls('ReorderSafetyQuantity', disabled);
        enableDisableControls('ReorderLeadTime', disabled);
        if (disabled) {
            setformFields(prevState => ({
                ...prevState,
                ReorderInventoryMinimumQty: null,
                ReorderInventoryMaximumQty: null,
                ReorderMinimumDaysOnHand: null,
                ReorderMaximumDaysOnHand: null,
                ReorderQuantityEntered: null,
                ReorderQuantityEoqCalculated: null,
                ReorderQuantityOrderMultiple: null,
                ReorderSafetyQuantity: null,
                ReorderLeadTime: null
            }));
        }
    }
    const goBack = () => {
        history.push("/om/codes/item-data-entry-list");
    };

    const EnableControlsForNewRecord = () => {

        if (formRefs.current["RProfile"] && formRefs.current["RProfile"].instance()) {
            formRefs.current["RProfile"].instance().option('disabled', false);
        }
        if (formRefs.current["PhysicalCountCode"]) {
            formRefs.current["PhysicalCountCode"].instance().option('disabled', false);
        }
    }

    const GetItemDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.IM.GetItem}?ProfileRowId=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                var responseData = response.data;
                if (responseData) {
                    responseData.RowId = '00000000-0000-0000-0000-000000000000';
                    responseData.Record = '';
                    responseData.CreationDateTime = null;
                    responseData.LastUpdateDateTime = null;
                    responseData.CreationUserId = '';
                    responseData.LastUpdateUserId = '';
                    responseData.CompanyId = '';
                    responseData.Module = IM;
                    responseData.RecordType = TransactionTypes.Receipt;
                    responseData.OnHand = 0;
                    responseData.InOrdered = 0;
                    responseData.OutOrdered = 0;
                    responseData.InReceiving = 0;
                    responseData.OutShipped = 0;
                    responseData.InBackOrder = 0;
                    responseData.OutBackOrder = 0;
                    responseData.InUnavailable = 0;
                    responseData.OutUnavailable = 0;
                    responseData.InFuture = 0;
                    responseData.OutFuture = 0;
                    responseData.Available = 0;
                    responseData.NetAvailable = 0;

                    // if customer has been entered, assume the user has already entered some information
                    // so only overwrite a field with the default value if the field is null}
                    // if customer has not been enterd then assign each field value of item profile to current item record}
                    for (const key in formFields) {
                        if (formFields[key] != null && formFields[key] != '') {
                            responseData[key] = formFields[key];
                        }
                    }
                    responseData.DateIntroduced = new Date();
                    responseData.DateAvailable = new Date();
                    responseData.StorageBillingStartDate = new Date();
                    responseData.StorageBillingEndDate = new Date(2999, 11, 31);
                    responseData.InventoryUnitNotUsed = 1;
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                    currentR_IDENTITY = responseData.RIdentity;
                    currentRATESELECTION = responseData.RateSelection;
                    currentCLASSCODE = responseData.ClassCode;
                    currentSUBCLASSCODE = responseData.SubClassCode;
                }
            }
            else {
                console.error('Failed to get item profile data');
            }
        } catch (error) {
            console.error('Error fetching item profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
        let currentFormFields = formFieldsRef.current;

        if (name == "RProfile" && !skipDataLoading && (formFieldsRef.current.RowId == "00000000-0000-0000-0000-000000000000")) {
            GetItemDataFromProfile(value);
        }
        if (name == "ReorderMethodFlag") {
            if (value == "N") {
                setReorderControlls(true);
            }
            else {
                setReorderControlls(false);
            }
        }
        if (name == "ItemType" && !skipDataLoading) {
            perviousItemType = e.previousValue;
        }

        if (name == "RateSource" && !skipDataLoading) {
            if (value == "L") {
                if (formRefs.current['RRateSchedule']) {
                    formRefs.current['RRateSchedule'].instance().option('disabled', true);
                }

                setformFields(prevState => ({
                    ...prevState,
                    RRateSchedule: null,
                }));

            }
            else {
                if (formRefs.current['RRateSchedule']) {
                    formRefs.current['RRateSchedule'].instance().option('disabled', false);
                }
            }

        }

        if (name == "RateSelection" && !skipDataLoading) {
            currentRATESELECTION = value;
            //loadRateScheduleLookupFromDataSource();
            setformFields(prevState => ({
                ...prevState,
                RRateSchedule: null,
            }));
        }

        if (name == "RIdentity" && !skipDataLoading) {
            currentR_IDENTITY = value;
            //loadRateScheduleLookupFromDataSource();
        }

        if (name == "ClassCode" && !skipDataLoading) {
            currentCLASSCODE = value;
            //loadRateScheduleLookupFromDataSource();
        }

        if (name == "SubClassCode" && !skipDataLoading) {
            currentSUBCLASSCODE = value;
            //loadRateScheduleLookupFromDataSource();
        }



        // Manually use PascalCase field names
        if (name == "GrossMinusNet") {
            let calculatedValue = currentFormFields.NetWeightQuantity + value;
            if (formRefs && formRefs.current && formRefs.current.GrossWeightQuantity) {
                const ref = formRefs.current.GrossWeightQuantity;
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('value', calculatedValue);
                    }
                }
            }
        }
        if (name == "NetWeightQuantity") {
            let calculatedValue = currentFormFields.GrossMinusNet + value;
            if (formRefs && formRefs.current && formRefs.current.GrossWeightQuantity) {
                const ref = formRefs.current.GrossWeightQuantity;
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('value', calculatedValue);
                    }
                }
            }
        }
        let itemType = currentFormFields.ItemType;

        if (name === "InventoryQuantitySource") {
            if (itemType < value) {
                setformFields(prevState => ({
                    ...prevState,
                    [name]: e.previousValue,
                }));
                alert('UOM Base Flag Must Be Less Then Or Equal To Item Type', 'Error');
            }
        }

        if (name === "WeightBasisFlag") {
            if (itemType < value) {
                setformFields(prevState => ({
                    ...prevState,
                    [name]: e.previousValue,
                }));
                alert('UOM Base Flag Must Be Less Then Or Equal To Item Type', 'Error');
            }
        }

        if (name == "CheckMaxDays" && value == "1" && value != undefined) {
            formRefs.current['MaxDays'].instance().option('disabled', true);
            formRefs.current['MaxDays'].instance().option('value', null);

        } else if (name == "CheckMaxDays" && value != "1" && value != undefined) {
            formRefs.current['MaxDays'].instance().option('disabled', false);
        }
              if (name === "PriceMethod") {
            if (value === PriceMethodEnum.DirectPrice) {
                DisableEnableControls("PriceBasis", true, formRefs);
                DisableEnableControls("CalcMethod", true, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    CalcMethod: null
                }));
            }
            else if (value !== PriceMethodEnum.DirectPrice) {
                DisableEnableControls("PriceBasis", false, formRefs);
                DisableEnableControls("CalcMethod", false, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    CalcMethod: CalcMethodEnum.PercentMarkup
                }));
            }
        }
        if (name == "PriceSource") {
            if (value ==PriceSourceEnum.PriceCode) {
                DisableEnableControls("PriceLevelA", true, formRefs);
                DisableEnableControls("PriceLevelB", true, formRefs);
                DisableEnableControls("PriceLevelC", true, formRefs);
                DisableEnableControls("PriceLevelD", true, formRefs);
                DisableEnableControls("PriceLevelE", true, formRefs);
                DisableEnableControls("CalcMethod", true, formRefs);
                DisableEnableControls("PriceBasis", true, formRefs);
                DisableEnableControls("PriceMethod", true, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    PriceLevelA: null,
                    PriceLevelB: null,
                    PriceLevelC: null,
                    PriceLevelD: null,
                    PriceLevelE: null,
                    CalcMethod: null,
                    PriceBasis: null,
                    PriceMethod: null
                }));
                DisableEnableControls("RPriceTable", false, formRefs);
            }
            else if (value ==PriceSourceEnum.SinglePrice) {
                DisableEnableControls("PriceLevelA", false, formRefs);
                DisableEnableControls("PriceLevelB", false, formRefs);
                DisableEnableControls("PriceLevelC", false, formRefs);
                DisableEnableControls("PriceLevelD", false, formRefs);
                DisableEnableControls("PriceLevelE", false, formRefs);
                DisableEnableControls("CalcMethod", false, formRefs);
                DisableEnableControls("PriceBasis", false, formRefs);
                DisableEnableControls("PriceMethod", false, formRefs);
                DisableEnableControls("RPriceTable", true, formRefs);
                setformFields(prevState => ({
                    ...prevState,
                    RPriceTable: null,
                    PriceMethod:PriceMethodEnum.DirectPrice,
                }));
            }
            if(value !==PriceSourceEnum.SinglePrice){
                setformFields(prevState => ({
                    ...prevState,
                    CalcMethod: CalcMethodEnum.PercentMarkup,
                }));
            }
        }

    });

    const handleUOMFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "InventoryQuantitySource", [{ id: 'I', name: "Item" }, { id: 'L', name: "Lot" }, { id: 'S', name: "Sublot" }]);
        loadLookupFromStaticData(formRefs, "WeightBasisFlag", [{ id: 'I', name: "Item" }, { id: 'L', name: "Lot" }, { id: 'S', name: "Sublot" }, { id: 'U', name: "Unit" }]);
        loadLookupFromStaticData(formRefs, "ReceiptUomDefault", [{ id: 'I', name: "Inventory Unit" }, { id: 'P', name: "Pieces" }, { id: 'P', name: "Packages (eg. Pallets)" }, { id: 'H', name: "Shipment (eg. Container)" }]);
        loadLookupFromStaticData(formRefs, "ShipmentUomDefault", [{ id: 'I', name: "Inventory Unit" }, { id: 'P', name: "Pieces" }, { id: 'K', name: "Packages (eg. Pallets)" }, { id: 'H', name: "Shipment (eg. Container)" }]);
        loadLookupFromStaticData(formRefs, "RfReceiptValidation", [{ id: 'Y', name: "EDI import to insert Serial # records for valdation by RF program" }, { id: 'N', name: "EDI import to gonre Serial # records or Serial #s do not exist" }]);
        loadLookupFromStaticData(formRefs, "RfShipmentValidation", [{ id: 'Y', name: "EDI import to insert Serial # records for valdation by RF program" }, { id: 'N', name: "EDI import to gonre Serial # records or Serial #s do not exist" }]);
        let calculatedValue = formFields['GrossWeightQuantity'] - formFields['NetWeightQuantity'];
        if (formRefs.current['GrossMinusNet']) {
            formRefs.current['GrossMinusNet'].instance().option('value', calculatedValue);
        }

        if (formRefs.current['InventoryUnitNotUsed']) {
            formRefs.current['InventoryUnitNotUsed'].instance().option('value', 1);
        }
    });

    // Status Tab start
    const statusFormLookupsLoad = () => {
        statusFormLoad();
    }

    const statusFormLoad = () => {
        loadLookupFromStaticData(formRefs, "ExpDateBasedOn", [{ id: 'N', name: "None" }, { id: 'A', name: "Receive/Ship date of Receipt" }, { id: 'B', name: "Lot Code as Truncated JD of Receipt" }, { id: 'C', name: "Lot Code as Modified JD of Receipt" }, { id: 'D', name: "Lot Code as Julian Day of Receipt" }]);
        loadLookupFromStaticData(formRefs, "WarrantyFlag", [{ id: 'N', name: "Not Applicable" }, { id: 'I', name: "Use Item Expiration Date" }, { id: 'L', name: "Use Lot Expiration Date" }, { id: 'S', name: "Use Sublot Expiration Date" }]);
        loadLookupFromStaticData(formRefs, "WarrantyFlagShipment", [{ id: 'N', name: "Not Applicable" }, { id: 'I', name: "Use Item Expiration Date" }, { id: 'L', name: "Use Lot Expiration Date" }, { id: 'S', name: "Use Sublot Expiration Date" }]);
        loadLookupFromStaticData(formRefs, "CheckReceiptDays", [{ id: '1', name: "No expiration days checking" }, { id: '2', name: "Check days and allow to continue" }, { id: '3', name: "Check days and do not allow to continue" }]);
        loadLookupFromStaticData(formRefs, "CheckShipmentDays", [{ id: '1', name: "No expiration days checking" }, { id: '2', name: "Check days and allow to continue" }, { id: '3', name: "Check days and do not allow to continue" }]);
        loadLookupFromStaticData(formRefs, "CheckMaxDays", [{ id: '1', name: "No" }, { id: '2', name: "Yes, check but allow override" }, { id: '3', name: "Yes, check but never allow override" }]);
        loadLookupFromStaticData(formRefs, "WmConsigneeExpDays", [{ id: 'N', name: "Do Not Adjust Expiration Days by Consignee" }, { id: 'Y', name: "Adjust Expiration Days by Consignee" }]);
        loadLookupFromStaticData(formRefs, "CheckLotExpiration", [{ id: 'N', name: "No" }, { id: 'Y', name: "Yes" }]);
    }
    const handleStatusFieldChange = (name, value) => {

    }

    // Status Tab End

    //HandlingTab////////////////////////
    const handlingFormLookupsLoad = () => {
        handlingFormLoad();
    }
    const handlingFormLoad = () => {
        loadLookupFromStaticData(formRefs, "SubLotUniqueFlag", [{ id: 'N', name: "Not Applicable" }, { id: 'Y', name: "All Sublots Created Will Be Assumed To Be Unique & Always Have a Quantity Of One" }]);
        loadLookupFromStaticData(formRefs, "HazardousFlag", [{ id: 'N', name: "No" }, { id: 'Y', name: "Yes" }]);
        loadLookupFromStaticData(formRefs, "ShipSelection", [{ id: 'N', name: "No, Serial # In Transaction Entry " }, { id: 'Y', name: "Yes, Use Serial # In Transaction Entry - Update Weights In Detail Based On Serial #" }, { id: 'U', name: "Yes, Use Serial # In Transaction Entry - Do Not Update Weights In Detail Based On Serial # " }]);
    }




    const handleHandlingFieldChange = (name, value) => {
        if (name == "RWarehouse") {
            setformFields(prevFields => ({
                ...prevFields,
                RLocation: '',
                RLocationBackupForwardPick: '',
                RLocationBackupReplenishment: '',
                RLocationBackupReserve: '',
                RLocationPrimaryReserve: '',
                RLocationPrimaryReplenishment: '',
            }));

        }
        if (name == "HazardousFlag" && value == "N" && value != undefined) {
            if (formRefs && formRefs.current && formRefs.current['RHazardous']) {
                const ref = formRefs.current['RHazardous'];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                        instance.option('value', null);
                    }
                }
            }
        } else if (name == "HazardousFlag" && value != "N" && value != undefined) {
            if (formRefs && formRefs.current && formRefs.current['RHazardous']) {
                const ref = formRefs.current['RHazardous'];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', false);
                    }
                }
            }
        }
    }
    const kitFormLookupsLoad = () => {
        KitFormLoad();
    }
    const KitFormLoad = () => {
        loadLookupFromStaticData(formRefs, "BomExplosionFlag", [{ id: 'N', name: 'Not Used' }, { id: 'M', name: 'Update Kit Item Quantities, during Commit of IM Receipts only' }, { id: 'I', name: 'Access Kit details from IM Transactions According TO IM Profile' }]);
        loadLookupFromStaticData(formRefs, "OmKitFlag", [{ id: 'N', name: 'Not Used' }, { id: 'S', name: 'Auto Explode Kit Inputs in OM Detail' }]);
        loadLookupFromStaticData(formRefs, "PmKitFlag", [{ id: 'A', name: 'Not Used' }, { id: 'B', name: 'Production Item' }, { id: 'C', name: 'Alternate Production Item' }]);
    }
    const handleKitFieldChange = (name, value) => {
        if (name == "BomExplosionFlag" && value == "N" && value != undefined) {
            if (formRefs && formRefs.current && formRefs.current['RItemKittCode']) {
                const ref = formRefs.current['RItemKittCode'];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                }
            }
        }
        else if (name == "BomExplosionFlag" && value != "N" && value != undefined) {
            if (formRefs && formRefs.current && formRefs.current['RItemKittCode']) {
                const ref = formRefs.current['RItemKittCode'];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', false);
                    }
                }
            }
        }
    }
    const reorderFormLoad = () => {
        loadLookupFromStaticData(formRefs, "ReorderMethodFlag", [{ id: 'N', name: "Not Applicable" }, { id: 'M', name: "Based on Minimum Quantity" }, { id: 'D', name: "Based on Minimum Days" }]);
        if (formFieldsRef.current.ReorderMethodFlag == "N") {
            setReorderControlls(true);
        }
        else {
            setReorderControlls(false);
        }
    }
    const costPriceFormLoad = () => {
        var TradeDisc = [{ id: 'Y', name: "Yes, Apply Custom Dscount" }, { id: 'N', name: "No" }];
        loadLookupFromStaticData(formRefs, "ArTradeDiscountFlag", TradeDisc);
        loadLookupFromStaticData(formRefs, "ArTermsDiscountFlag", TradeDisc);
        loadLookupFromStaticData(formRefs, "CostBasisMethodFlag", [{ id: 'S', name: "Standard Cost" }, { id: 'A', name: "Average Cost" }, { id: 'L', name: "Last Cost" }]);
        loadLookupFromStaticData(formRefs, "RoundingMethod", [{ id: 'A', name: "Round Up To Factor" }, { id: 'B', name: "Round Down To Factor" }, { id: 'C', name: "Round To Nearest Factor" }, { id: 'N', name: "Round Up To #" }, { id: 'E', name: "Round Down To #" }, { id: 'F', name: "Round To Nearest #" }]);
        loadLookupFromStaticData(formRefs, "PriceSource", [{ id: 'S', name: "Single Price" }, { id: 'P', name: "Price Code" },]);
        loadLookupFromStaticData(formRefs, "PriceMethod", [{ id: 'D', name: "Direct Price" }, { id: 'B', name: "Basis Price" }, { id: 'S', name: "Standard Cost" }, { id: 'A', name: "Average Cost" }, { id: 'L', name: "Last Cost" }]);
        loadLookupFromStaticData(formRefs, "CalcMethod", [{ id: 'M', name: "% Markup" }, { id: 'G', name: "Gross Margin" }, { id: 'F', name: "Fixed Markup" }]);
        if (formFieldsRef.current.PriceMethod === PriceMethodEnum.DirectPrice) {
                   DisableEnableControls("PriceBasis", true,formRefs);
                   DisableEnableControls("CalcMethod", true,formRefs);
                   setformFields(prevState => ({
                       ...prevState,
                       CalcMethod: null
                   }));
               }
               else if (formFieldsRef.current.PriceMethod !== PriceMethodEnum.DirectPrice) {
                   DisableEnableControls("PriceBasis", false,formRefs);
                   DisableEnableControls("CalcMethod", false,formRefs);
               }
               if (formFieldsRef.current.PriceSource == PriceSourceEnum.PriceCode || formFieldsRef.current.PriceSource ===PriceSourceEnum.ItemMaster) {
                   DisableEnableControls("PriceLevelA", true,formRefs);
                   DisableEnableControls("PriceLevelB", true,formRefs);
                   DisableEnableControls("PriceLevelC", true,formRefs);
                   DisableEnableControls("PriceLevelD", true,formRefs);
                   DisableEnableControls("PriceLevelE", true,formRefs);
                   DisableEnableControls("CalcMethod", true,formRefs);
                   DisableEnableControls("PriceBasis", true,formRefs);
                   DisableEnableControls("PriceMethod", true,formRefs);
                   setformFields(prevState => ({
                       ...prevState,
                       PriceLevelA: null,
                       PriceLevelB: null,
                       PriceLevelC: null,
                       PriceLevelD: null,
                       PriceLevelE: null,
                       CalcMethod: null,
                       PriceBasis: null,
                       PriceMethod: null
                   }));
                   DisableEnableControls("RPriceTable", false,formRefs);
               }
               else if (formFieldsRef.current.PriceSource ==PriceSourceEnum.SinglePrice) {
                   DisableEnableControls("PriceLevelA", false,formRefs);
                   DisableEnableControls("PriceLevelB", false,formRefs);
                   DisableEnableControls("PriceLevelC", false,formRefs);
                   DisableEnableControls("PriceLevelD", false,formRefs);
                   DisableEnableControls("PriceLevelE", false,formRefs);
                   DisableEnableControls("PriceMethod", false,formRefs);
                   DisableEnableControls("RPriceTable", true,formRefs);
                   setformFields(prevState => ({
                       ...prevState,
                       RPriceTable: null
                   }));
        }
    }
    const miscFormLookupsLoad = () => {
        loadLookupFromStaticData(formRefs, "CommissionBasis", [{ id: 'A', name: "Percent" }, { id: 'U', name: "Per Unit" }, { id: 'F', name: "Flat" }
            , { id: 'L', name: "Last Cost at Time Of OM Entry" }, { id: 'V', name: "Average Cost at Time of OM Entry" }, { id: 'S', name: "Standard Cost at Time of OM Entry" }
        ]);
        loadLookupFromStaticData(formRefs, "WebAccessibility", [{ id: 'A', name: "Accessible to both salespeople and customers" }, { id: 'S', name: "Accessible only to salespeople" }, { id: 'C', name: "Accessible only to customers" }, { id: 'N', name: "Not accessible" }]);
        loadLookupFromStaticData(formRefs, "ShipSelection", [{ id: 'N', name: "No, Serial # in Transaction Entry" }, { id: 'Y', name: "Yes, Use Serial # In Transaction Entry - Do Not Update Weights In Detail Based On Serial" }, { id: 'U', name: "Yes, Use Serial # In Transaction Entry - Update Weights In Detail Based On Serial" }]);
        loadLookupFromStaticData(formRefs, "UpdateUomWeight", [{ id: 'N', name: "Not Applicable" }, { id: 'Y', name: "Yes, Update Average Weights Based on Serial #" }]);
        loadLookupFromStaticData(formRefs, "AutomaticallyUpdateQuantity", [{ id: 'N', name: "No, Not Applicable" }, { id: 'U', name: "Yes, Update Units as Quantity" }, { id: 'W', name: "Yes, Update Weight as Quantity" }]);
    }
    //HandlingTab////////////////////////
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Item Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.RowId === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button
                                        className="accordianButton"
                                        onClick={goBack}
                                        text="Back"
                                        disabled={!backButtonEnabled}
                                    />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"} onSelectionChanged={handleTabSelection}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="UOM" >
                                    <UOMTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleUOMFormLoad={handleUOMFormLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Cost/Price">
                                    <CostPriceTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} costPriceFormLoad={costPriceFormLoad} formRefs={formRefs} loadPriceDataGrid={loadPriceDataGrid} isTabVisible={selectedTabIndex === 2} onGridReady={costPriceGridRef} />
                                </TabItem>
                                <TabItem title="Handling">
                                    <HandlingTab formFields={formFields} setformFields={setformFields} handleHandlingFieldChange={handleHandlingFieldChange} handlingFormLookupsLoad={handlingFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Reorder">
                                    <ReorderTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} reorderFormLoad={reorderFormLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Status">
                                    <StatusTab formFields={formFields} setformFields={setformFields} handleStatusFieldChange={handleStatusFieldChange} statusFormLookupsLoad={statusFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Misc">
                                    <MiscTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} miscFormLookupsLoad={miscFormLookupsLoad} handleSelectionChange={handleSelectionChange} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Locations">
                                    <LocationsTab formFields={formFields} />
                                </TabItem>
                                <TabItem title="Kit/Core" >
                                    <KitTab formFields={formFields} setformFields={setformFields} handleKitFieldChange={handleKitFieldChange} kitFormLookupsLoad={kitFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Lots" disabled={formFields.ItemType !== ItemTypes.Lot}>
                                    <LotTab rowId={formFields.RowId} />
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
